import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as nls from '../../../nls.js';
import { EditorAction, registerEditorAction } from '../../browser/editorExtensions.js';
import { ReplaceCommand } from '../../common/commands/replaceCommand.js';
import { Range } from '../../common/core/range.js';
import { EditorContextKeys } from '../../common/editorContextKeys.js';
import { MoveOperations } from '../../common/controller/cursorMoveOperations.js';

var TransposeLettersAction = /*#__PURE__*/function (_EditorAction) {
  _inherits(TransposeLettersAction, _EditorAction);

  var _super = _createSuper(TransposeLettersAction);

  function TransposeLettersAction() {
    _classCallCheck(this, TransposeLettersAction);

    return _super.call(this, {
      id: 'editor.action.transposeLetters',
      label: nls.localize('transposeLetters.label', "Transpose Letters"),
      alias: 'Transpose Letters',
      precondition: EditorContextKeys.writable,
      kbOpts: {
        kbExpr: EditorContextKeys.textInputFocus,
        primary: 0,
        mac: {
          primary: 256
          /* WinCtrl */
          | 50
          /* KEY_T */

        },
        weight: 100
        /* EditorContrib */

      }
    });
  }

  _createClass(TransposeLettersAction, [{
    key: "run",
    value: function run(accessor, editor) {
      if (!editor.hasModel()) {
        return;
      }

      var model = editor.getModel();
      var commands = [];
      var selections = editor.getSelections();

      var _iterator = _createForOfIteratorHelper(selections),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var selection = _step.value;

          if (!selection.isEmpty()) {
            continue;
          }

          var lineNumber = selection.startLineNumber;
          var column = selection.startColumn;
          var lastColumn = model.getLineMaxColumn(lineNumber);

          if (lineNumber === 1 && (column === 1 || column === 2 && lastColumn === 2)) {
            // at beginning of file, nothing to do
            continue;
          } // handle special case: when at end of line, transpose left two chars
          // otherwise, transpose left and right chars


          var endPosition = column === lastColumn ? selection.getPosition() : MoveOperations.rightPosition(model, selection.getPosition().lineNumber, selection.getPosition().column);
          var middlePosition = MoveOperations.leftPosition(model, endPosition.lineNumber, endPosition.column);
          var beginPosition = MoveOperations.leftPosition(model, middlePosition.lineNumber, middlePosition.column);
          var leftChar = model.getValueInRange(Range.fromPositions(beginPosition, middlePosition));
          var rightChar = model.getValueInRange(Range.fromPositions(middlePosition, endPosition));
          var replaceRange = Range.fromPositions(beginPosition, endPosition);
          commands.push(new ReplaceCommand(replaceRange, rightChar + leftChar));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (commands.length > 0) {
        editor.pushUndoStop();
        editor.executeCommands(this.id, commands);
        editor.pushUndoStop();
      }
    }
  }]);

  return TransposeLettersAction;
}(EditorAction);

registerEditorAction(TransposeLettersAction);